import { render } from "./YoutubeCustom.vue?vue&type=template&id=607caaa2&scoped=true"
import script from "./YoutubeCustom.vue?vue&type=script&lang=js"
export * from "./YoutubeCustom.vue?vue&type=script&lang=js"

import "./YoutubeCustom.vue?vue&type=style&index=0&id=607caaa2&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607caaa2"]])

export default __exports__